import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { nativeIssueTableEntryPoint } from '@atlassian/jira-native-issue-table/src/ui/entrypoint.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { jqlBuilderWithAiEntryPoint } from '@atlassian/jira-jql-builder-with-ai/src/ui/entrypoint.tsx';
import { issueAppEntryPoint } from '@atlassian/jira-issue-view/src/views/issue-details/issueAppEntryPoint.tsx';

export const globalIssueNavigatorEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-global-issue-navigator-entrypoint" */ './src'),
		{ entryFsSsrLiftImportToModule: true },
	),
	getPreloadProps: (entryPointParams: EntryPointRouteParams) => {
		if (!fg('nin_remove_global_scope_enrolment')) {
			return {};
		}
		let issueKey = entryPointParams?.context?.match?.params?.issueKey;

		// current prod bug workaround: issueKey is always undefined since issueKey is passed in as selectedIssue from query param
		if (fg('nin_issue_app_conditional_entrypoint')) {
			issueKey = entryPointParams?.context?.query?.selectedIssue;
		}

		let preloadProps = {};
		// exclude nativeIssueTableEntryPoint and jqlBuilderWithAiEntryPoint from preloading on the issue route
		if (!issueKey) {
			preloadProps = {
				entryPoints: {
					nativeIssueTableEntryPoint: {
						entryPoint: nativeIssueTableEntryPoint,
						entryPointParams,
					},
					...(fg('jql_builder_basic_ssr_stability_fixes')
						? {
								jqlBuilderWithAiEntryPoint: {
									entryPoint: jqlBuilderWithAiEntryPoint,
									entryPointParams,
								},
							}
						: {}),
				},
			};
		} else if (issueKey && fg('nin_issue_app_conditional_entrypoint')) {
			preloadProps = {
				entryPoints: {
					issueAppEntryPoint: {
						entryPoint: issueAppEntryPoint,
						entryPointParams,
					},
				},
			};
		}

		return preloadProps;
	},
});
